<template>
  <div class="preview-result text-start p-3 text-darkblue position-relative pb-4" style="min-height:100%; min-width:100%;">
    <h3 class="h6">{{ shortTitle }}</h3>
    <div>{{ dates }} {{ hours }}</div>
    <div class="my-2 pb-5" v-html="shortText"></div>
    <a :href="result.url" target="_blank" class="btn bg-darkblue position-absolute start-0 ms-3 resultlink" style="bottom: 1em;">INFOS & ANMELDUNG <span class="sr-only">für die Veranslatung {{ ariaLabel  }}</span></a>
  </div>
</template>

<script setup>
import { returnDateString, parseHourStr } from "@/shared/utils";
import { defineProps, ref } from "vue";
import ResultHeader from "@/components/Veranstaltungen/ResultHeader";

const props = defineProps({
  result: Object,
});
const { result } = props;

const dates =
  result.sebes == result.seend
    ? returnDateString(result.sebes)
    : returnDateString(result.sebes) + " - " + returnDateString(result.seend);
const hours =
  result.vuhr !== "0,00" && result.buhr !== "0,00"
    ? parseHourStr(result.vuhr) + " - " + parseHourStr(result.buhr) + " Uhr"
    : result.vuhr !== "0,00"
    ? parseHourStr(result.vuhr) + " Uhr"
    : "";
const text = result.inhalte['02']?.inhalt?.replace(/<(.|\n)*?>/g, '');
const shortText = text?.replace(/(.{150})..+/, "$1&hellip;");
const shortTitle = result.sembez?.replace(/(.{80})..+/, "$1...");
const ariaLabel = "Veranstaltung: " + shortTitle;

</script>

<style></style>
